/**
 * Romanian Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const ro: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Tablou de bord',
  'nav.funds': 'Fonduri',
  'nav.investments': 'Investiții',
  'nav.investees': 'Beneficiari investiții',
  'nav.esg': 'ESG Revizuire',
  'nav.compliance': 'Conformitate',
  'nav.reports': 'Rapoarte',
  'nav.settings': 'Setări',
  'nav.users': 'Utilizatori',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Indicatori',
  'nav.taxonomy': 'Taxonomia UE',
  'nav.filings': 'Raportări',
  'nav.calendar': 'Calendar',
  'nav.submit': 'Trimite date',
  'nav.submissions': 'Trimiterile mele',
  'nav.benchmarks': 'Referințe',
  'nav.messages': 'Mesaje',
  'nav.portfolio': 'Portofoliu',
  'nav.performance': 'Performanța fondurilor',
  'nav.esgSummary': 'ESG Sumar',
  'nav.pipeline': 'Conductă',
  'nav.dueDiligence': 'Due Diligence',
  'nav.impact': 'Indicatori de impact',
  'nav.sdg': 'Mapare ODD',
  'nav.audit': 'Urmă de audit',
  'nav.snapshots': 'Instantanee date',
  'nav.knowledgeGraph': 'Graful cunoașterii',
  'nav.geographic': 'Geografic',
  'nav.bi': 'BI Studio',
  'nav.ai': 'Asistent AI',
  'nav.tasks': 'Sarcini',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Monitor de reglementare',

  // Common Actions
  'action.create': 'Creează',
  'action.edit': 'Editează',
  'action.delete': 'Șterge',
  'action.save': 'Salvează',
  'action.cancel': 'Anulează',
  'action.submit': 'Trimite',
  'action.approve': 'Aprobă',
  'action.reject': 'Respinge',
  'action.download': 'Descarcă',
  'action.export': 'Exportă',
  'action.import': 'Importă',
  'action.filter': 'Filtrează',
  'action.search': 'Caută',
  'action.refresh': 'Reîmprospătează',
  'action.close': 'Închide',
  'action.back': 'Înapoi',
  'action.next': 'Următorul',
  'action.previous': 'Anteriorul',
  'action.viewAll': 'Vezi tot',
  'action.viewDetails': 'Vezi detalii',
  'action.generate': 'Generează',
  'action.signOut': 'Deconectare',
  'action.addNew': 'Adaugă nou',
  'action.invite': 'Invită',

  // Statuses
  'status.draft': 'Ciornă',
  'status.submitted': 'Trimis',
  'status.validated': 'Validat',
  'status.approved': 'Aprobat',
  'status.rejected': 'Respins',
  'status.pending': 'În așteptare',
  'status.inProgress': 'În curs',
  'status.overdue': 'Întârziat',
  'status.compliant': 'Conform',
  'status.filed': 'Raportat',
  'status.active': 'Activ',
  'status.inactive': 'Inactiv',
  'status.closed': 'Închis',
  'status.fundraising': 'Strângere de fonduri',
  'status.investing': 'Investire',
  'status.harvesting': 'Recoltare',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Prezentare generală a portofoliului',
  'dashboard.complianceStatus': 'Starea conformității',
  'dashboard.collectionProgress': 'Progresul colectării',
  'dashboard.activityFeed': 'Activitate',
  'dashboard.quickActions': 'Acțiuni rapide',
  'dashboard.investmentPipeline': 'Conductă de investiții',
  'dashboard.totalFunds': 'Total fonduri',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Investiții active',
  'dashboard.totalInvestees': 'Beneficiari investiții',
  'dashboard.recentActivity': 'Activitate recentă',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Total angajat',
  'lp.capitalCalled': 'Capital solicitat',
  'lp.distributed': 'Distribuit',
  'lp.netPosition': 'Poziție netă',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Performanța fondurilor',
  'lp.esgSummary': 'ESG Sumar',
  'lp.reportLibrary': 'Biblioteca de rapoarte',
  'lp.taxonomyAligned': 'Aliniat la taxonomie',
  'lp.paiCoverage': 'PAI Acoperire',
  'lp.portfolioPerformance': 'Performanța portofoliului LP',

  // Fund Labels
  'fund.name': 'Numele fondului',
  'fund.code': 'Codul fondului',
  'fund.vintage': 'Anul înființării',
  'fund.size': 'Dimensiunea fondului',
  'fund.targetSize': 'Dimensiune țintă',
  'fund.currency': 'Monedă',
  'fund.strategy': 'Strategie',
  'fund.status': 'Stare',
  'fund.sfdrCategory': 'SFDR Categorie',
  'fund.geographyFocus': 'Focus geografic',
  'fund.sectorFocus': 'Focus sectorial',

  // Form Labels
  'form.name': 'Nume',
  'form.email': 'E-mail',
  'form.country': 'Țară',
  'form.amount': 'Sumă',
  'form.currency': 'Monedă',
  'form.date': 'Dată',
  'form.description': 'Descriere',
  'form.notes': 'Note',
  'form.type': 'Tip',
  'form.period': 'Perioadă',
  'form.year': 'An',
  'form.required': 'Obligatoriu',
  'form.optional': 'Opțional',

  // Table Headers
  'table.fund': 'Fond',
  'table.commitment': 'Angajament',
  'table.called': 'Solicitat',
  'table.distributed': 'Distribuit',
  'table.tvpi': 'TVPI',
  'table.status': 'Stare',
  'table.regulation': 'Reglementare',
  'table.filingType': 'Tip de raportare',
  'table.reportingPeriod': 'Perioadă',
  'table.createdAt': 'Creat',
  'table.actions': 'Acțiuni',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'Taxonomia UE',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Completitudinea datelor',
  'compliance.nextDeadline': 'Următorul termen limită',

  // Reports
  'report.quarterly': 'Raport trimestrial',
  'report.annual': 'Raport anual',
  'report.paiStatement': 'PAI Declarație',
  'report.taxonomyReport': 'Raport de taxonomie',
  'report.generatedAt': 'Generat',
  'report.version': 'Versiune',

  // General
  'general.loading': 'Se încarcă...',
  'general.noData': 'Nu sunt date disponibile',
  'general.error': 'A apărut o eroare',
  'general.retry': 'Reîncearcă',
  'general.total': 'Total',
  'general.page': 'Pagină',
  'general.of': 'din',
  'general.showing': 'Se afișează',
  'general.results': 'rezultate',
  'general.language': 'Limbă',
  'general.english': 'Engleză',
  'general.french': 'Franceză',

  // Tour
  'tour.takeTour': 'Incepe turul',
  'tour.skip': 'Sari peste',
  'tour.next': 'Urmatorul',
  'tour.prev': 'Anteriorul',
  'tour.finish': 'Termina',
};
